module.exports = __webpack_public_path__ + "img/rear-4.2ad32015.jpg";